export const errorMessages = Object.freeze({
  regex: {
    defaultMessage: ' * Failed regex check',
  },
  dash: {
    defaultMessage: ' * Should NOT include any dash.',
  },
  underscore: {
    defaultMessage: ' * Should NOT include any underscore.',
  },
} as const);
